var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty.js");

var _objectWithoutProperties = require("/opt/build/repo/node_modules/@babel/runtime/helpers/objectWithoutProperties.js");

var _excluded = ["size"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _extends() {
  return _extends = Object.assign || function (a) {
    for (var b, c = 1; c < arguments.length; c++) {
      for (var d in b = arguments[c], b) {
        Object.prototype.hasOwnProperty.call(b, d) && (a[d] = b[d]);
      }
    }

    return a;
  }, _extends.apply(this, arguments);
}

var React = require("react");

module.exports = function (a) {
  var _a$size = a.size,
      c = _a$size === void 0 ? "1em" : _a$size,
      b = _objectWithoutProperties(a, _excluded);

  return b = _objectSpread(_objectSpread({}, b), {}, {
    style: _objectSpread(_objectSpread({}, b.style ? b.style : {}), {}, {
      width: c,
      height: c
    })
  }), /*#__PURE__*/React.createElement("svg", _extends({}, b, {
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.563 79.748c-3.83 0-6.724-1.118-8.714-3.355-1.99-2.237-2.985-5.44-2.985-9.612 0-4.262 1.025-7.527 3.106-9.824 2.08-2.297 5.065-3.446 9.015-3.446 2.653 0 5.065.484 7.176 1.481l-1.628 4.323c-2.262-.877-4.131-1.33-5.608-1.33-4.372 0-6.543 2.902-6.543 8.705 0 2.841.543 4.957 1.628 6.408 1.085 1.42 2.683 2.146 4.794 2.146 2.382 0 4.643-.604 6.784-1.783v4.685c-.965.574-1.99.967-3.075 1.21-1.086.271-2.412.392-3.95.392zm21.829-.453h-5.367V43.688h5.367v35.607z",
    fill: "#96CA4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.985 90.539c-1.598 0-2.955-.181-4.01-.574v-4.262a12.3 12.3 0 003.166.423c2.291 0 3.437-1.3 3.437-3.9v-28.26h5.367V82.59c0 2.6-.694 4.595-2.05 5.925-1.387 1.36-3.347 2.025-5.91 2.025zm2.261-43.254c0-.968.272-1.693.784-2.207.513-.514 1.266-.786 2.261-.786.935 0 1.689.272 2.201.786.513.514.784 1.27.784 2.207 0 .906-.271 1.632-.784 2.176-.512.514-1.266.786-2.2.786-.965 0-1.72-.272-2.262-.786-.543-.544-.784-1.27-.784-2.176zm33.8 24.816c0 2.478-.905 4.352-2.684 5.682-1.81 1.33-4.372 1.965-7.719 1.965-3.377 0-6.06-.514-8.11-1.541v-4.655c2.954 1.36 5.728 2.055 8.291 2.055 3.287 0 4.945-.997 4.945-2.992 0-.635-.181-1.18-.543-1.602-.362-.424-.965-.877-1.809-1.33-.844-.454-1.99-.968-3.497-1.542-2.895-1.118-4.885-2.267-5.91-3.385-1.025-1.119-1.538-2.6-1.538-4.383 0-2.177.875-3.839 2.623-5.048 1.75-1.21 4.101-1.783 7.116-1.783 2.955 0 5.759.604 8.412 1.813l-1.749 4.05c-2.713-1.118-5.005-1.692-6.874-1.692-2.834 0-4.251.816-4.251 2.418 0 .786.362 1.45 1.115 2.025.724.544 2.352 1.3 4.824 2.267 2.08.816 3.588 1.542 4.553 2.207.935.665 1.628 1.45 2.11 2.327.453.847.694 1.904.694 3.144z",
    fill: "#5F7FBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.176 117.864C30.678 115.416 9.03 92.171 9.03 63.97c0-28.202 21.648-51.416 49.146-53.864V4.03C27.332 6.51 3 32.443 3 64s24.332 57.491 55.176 59.97v-6.106z",
    fill: "#96CA4B",
    stroke: "#96CA4B",
    strokeWidth: "6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.824 4.03v6.076C95.322 12.554 116.97 35.798 116.97 64c0 28.202-21.648 51.446-49.146 53.894v6.076C98.668 121.49 123 95.557 123 64S98.668 6.509 67.824 4.03z",
    fill: "#5F7FBF",
    stroke: "#5F7FBF",
    strokeWidth: "6"
  })));
};